function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M23.1875 10.4919H19.9062V9.24188C19.9062 9.15594 19.8359 9.08563 19.75 9.08563H18.6562C18.5703 9.08563 18.5 9.15594 18.5 9.24188V10.4919H13.5V9.24188C13.5 9.15594 13.4297 9.08563 13.3438 9.08563H12.25C12.1641 9.08563 12.0938 9.15594 12.0938 9.24188V10.4919H8.8125C8.4668 10.4919 8.1875 10.7712 8.1875 11.1169V24.0856C8.1875 24.4313 8.4668 24.7106 8.8125 24.7106H23.1875C23.5332 24.7106 23.8125 24.4313 23.8125 24.0856V11.1169C23.8125 10.7712 23.5332 10.4919 23.1875 10.4919ZM19.5645 15.3493L15.4121 21.0661C15.3829 21.1061 15.3447 21.1386 15.3006 21.161C15.2565 21.1834 15.2077 21.195 15.1582 21.195C15.1087 21.195 15.0599 21.1834 15.0158 21.161C14.9717 21.1386 14.9335 21.1061 14.9043 21.0661L12.4355 17.6677C12.3613 17.5641 12.4355 17.4196 12.5625 17.4196H13.6406C13.7402 17.4196 13.8359 17.4684 13.8945 17.5485L15.1582 19.2868L18.1055 15.2282C18.1641 15.1481 18.2578 15.0993 18.3594 15.0993H19.4375C19.5645 15.1013 19.6387 15.2458 19.5645 15.3493Z",
  fill: "#15A9E1"
});

var _ref3 = /*#__PURE__*/React.createElement("rect", {
  x: 0.75,
  y: 1.64813,
  width: 30.5,
  height: 30.5,
  rx: 15.25,
  stroke: "#15A9E1",
  strokeWidth: 1.5
});

var SvgCheckCircle = function SvgCheckCircle(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 33,
    viewBox: "0 0 32 33",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgCheckCircle, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/check-circle.38ca26f7.svg";
export { ForwardRef as ReactComponent };